import { render, staticRenderFns } from "./ListadoArmasModal.vue?vue&type=template&id=86c70904&scoped=true"
import script from "./ListadoArmasModal.vue?vue&type=script&lang=js"
export * from "./ListadoArmasModal.vue?vue&type=script&lang=js"
import style0 from "./ListadoArmasModal.vue?vue&type=style&index=0&id=86c70904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c70904",
  null
  
)

export default component.exports